export interface FaqItem {
  question: string
  answer: string
  list?: string[]
  outro?: string
}

export const faqs: FaqItem[] = [
  {
    question: 'How do I access the material?',
    answer:
      'Immediately after purchase you get all 6 volumes and 5 bonuses as downloadable PDFs — on your phone, tablet or computer. Download once, access forever.',
  },
  {
    question: 'What level of coach is this for?',
    answer:
      'High school, club and university coaches, PE teachers and solo coaches with large or mixed groups. Every volume goes from Tier 1 (Beginner) to Tier 3 (Advanced).',
  },
  {
    question: 'Does it work worldwide?',
    answer:
      'Yes. It’s organized by training principles, not by country or federation — it works for US, UK, Australian, Canadian and international programs.',
  },
  {
    question: 'What if I don’t have a professional track?',
    answer:
      'The Low-Resource Coach Playbook shows you how to adapt every session to grass, parking lots or shared facilities — with cones and a stopwatch.',
  },
  {
    question: 'Can I use this if I coach alone?',
    answer:
      'Yes. Volume 5 includes one-coach team management and station rotations to run 40+ athletes without an assistant.',
  },
  {
    question: 'What if it doesn’t work for me?',
    answer:
      'You have 7 days. Try the system in your coaching — if it isn’t right for you, we refund 100% of your purchase. No questions asked.',
  },
]
